export default __webpack_public_path__ + "static/media/cavinimg.77adeaa3.jpg";